export const DEFAULT_DATA_CENTER_THEME_ID = 'ocean-whale';

export const dataCenterThemes = Object.freeze([
  {
    id: 'ocean-whale',
    label: '海洋鲸鱼',
    asset: new URL('../assets/data-center-whale-card.png', import.meta.url).href,
    palette: { glow: 'rgba(205, 239, 255, 0.42)', softGlow: 'rgba(235, 248, 255, 0.22)', tail: '#f7fbff' },
    artwork: {
      width: '220px', right: '-18px', bottom: '-18px', scaleX: 0.88,
      filter: 'saturate(1.55) contrast(1.25) brightness(0.97) drop-shadow(0 1px 2px rgba(82, 183, 241, 0.18))',
    },
  },
  {
    id: 'ford-mustang',
    label: '福特野马跑车',
    asset: new URL('../assets/data-center-themes/data-center-mustang-card.png', import.meta.url).href,
    palette: { glow: 'rgba(210, 232, 255, 0.34)', softGlow: 'rgba(255, 232, 214, 0.16)', tail: '#fbfdff' },
    artwork: {
      width: '268px', right: '-10px', bottom: '-10px', scaleX: 0.94,
      filter: 'saturate(1.08) contrast(1.06) brightness(1.02) drop-shadow(0 2px 3px rgba(66, 111, 160, 0.14))',
    },
  },
  {
    id: 'star-rocket',
    label: '星空火箭',
    asset: new URL('../assets/data-center-themes/data-center-rocket-card.png', import.meta.url).href,
    palette: { glow: 'rgba(218, 220, 255, 0.36)', softGlow: 'rgba(239, 225, 255, 0.18)', tail: '#fbfaff' },
    artwork: {
      width: '204px', right: '-14px', bottom: '-22px', scaleX: 0.95,
      filter: 'saturate(1.08) contrast(1.04) brightness(1.03) drop-shadow(0 2px 3px rgba(107, 99, 190, 0.13))',
    },
  },
  {
    id: 'forest-deer',
    label: '森林小鹿',
    asset: new URL('../assets/data-center-themes/data-center-deer-card.png', import.meta.url).href,
    palette: { glow: 'rgba(218, 244, 224, 0.38)', softGlow: 'rgba(244, 238, 210, 0.16)', tail: '#fbfefb' },
    artwork: {
      width: '172px', right: '-12px', bottom: '-19px', scaleX: 0.96,
      filter: 'saturate(1.06) contrast(1.04) brightness(1.03) drop-shadow(0 2px 3px rgba(82, 137, 92, 0.12))',
    },
  },
  {
    id: 'snow-penguin',
    label: '雪地企鹅',
    asset: new URL('../assets/data-center-themes/data-center-penguin-card.png', import.meta.url).href,
    palette: { glow: 'rgba(213, 241, 255, 0.4)', softGlow: 'rgba(233, 248, 255, 0.2)', tail: '#f8fcff' },
    artwork: {
      width: '182px', right: '-12px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.04) contrast(1.04) brightness(1.04) drop-shadow(0 2px 3px rgba(71, 151, 194, 0.12))',
    },
  },
  {
    id: 'festival-gift',
    label: '节日礼物',
    asset: new URL('../assets/data-center-themes/data-center-gift-card.png', import.meta.url).href,
    palette: { glow: 'rgba(255, 224, 222, 0.34)', softGlow: 'rgba(255, 244, 205, 0.18)', tail: '#fffdfb' },
    artwork: {
      width: '140px', right: '-12px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.06) contrast(1.04) brightness(1.03) drop-shadow(0 2px 3px rgba(176, 92, 84, 0.12))',
    },
  },
  {
    id: 'mazda-mx5',
    label: 'MAZDA MX-5',
    asset: new URL('../assets/data-center-themes/data-center-mx5-card.png', import.meta.url).href,
    palette: { glow: 'rgba(255, 224, 220, 0.34)', softGlow: 'rgba(226, 240, 255, 0.16)', tail: '#fffdfd' },
    artwork: {
      width: '268px', right: '-10px', bottom: '-10px', scaleX: 0.94,
      filter: 'saturate(1.08) contrast(1.05) brightness(1.02) drop-shadow(0 2px 3px rgba(166, 78, 72, 0.13))',
    },
  },
  {
    id: 'ford-f150-black',
    label: 'FORD F-150',
    asset: new URL('../assets/data-center-themes/data-center-f150-black-card.png', import.meta.url).href,
    palette: { glow: 'rgba(205, 225, 244, 0.3)', softGlow: 'rgba(227, 239, 250, 0.16)', tail: '#fafcff' },
    artwork: {
      width: '276px', right: '-10px', bottom: '-8px', scaleX: 0.94,
      filter: 'saturate(0.92) contrast(1.08) brightness(1.04) drop-shadow(0 2px 3px rgba(48, 68, 88, 0.16))',
    },
  },
  {
    id: 'sakura',
    label: '樱花',
    asset: new URL('../assets/data-center-themes/data-center-sakura-card.png', import.meta.url).href,
    palette: { glow: 'rgba(255, 220, 232, 0.36)', softGlow: 'rgba(255, 239, 245, 0.2)', tail: '#fffafd' },
    artwork: {
      width: '154px', right: '-12px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.03) contrast(1.03) brightness(1.04) drop-shadow(0 2px 3px rgba(196, 112, 142, 0.1))',
    },
  },
  {
    id: 'maple',
    label: '枫叶',
    asset: new URL('../assets/data-center-themes/data-center-maple-card.png', import.meta.url).href,
    palette: { glow: 'rgba(255, 229, 204, 0.38)', softGlow: 'rgba(255, 242, 221, 0.18)', tail: '#fffaf5' },
    artwork: {
      width: '192px', right: '-12px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.06) contrast(1.04) brightness(1.03) drop-shadow(0 2px 3px rgba(188, 105, 52, 0.11))',
    },
  },
  {
    id: 'coffee',
    label: '咖啡',
    asset: new URL('../assets/data-center-themes/data-center-coffee-card.png', import.meta.url).href,
    palette: { glow: 'rgba(244, 224, 205, 0.36)', softGlow: 'rgba(255, 243, 228, 0.2)', tail: '#fffaf5' },
    artwork: {
      width: '200px', right: '-10px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.02) contrast(1.03) brightness(1.04) drop-shadow(0 2px 3px rgba(139, 95, 60, 0.11))',
    },
  },
  {
    id: 'bamboo',
    label: '竹子',
    asset: new URL('../assets/data-center-themes/data-center-bamboo-card.png', import.meta.url).href,
    palette: { glow: 'rgba(219, 242, 222, 0.38)', softGlow: 'rgba(237, 248, 237, 0.2)', tail: '#f9fdf9' },
    artwork: {
      width: '194px', right: '-10px', bottom: '-20px', scaleX: 1,
      filter: 'saturate(1.04) contrast(1.03) brightness(1.04) drop-shadow(0 2px 3px rgba(72, 132, 79, 0.1))',
    },
  },
].map((theme) => Object.freeze({
  ...theme,
  palette: Object.freeze(theme.palette),
  artwork: Object.freeze(theme.artwork),
})));

const themeById = new Map(dataCenterThemes.map((theme) => [theme.id, theme]));

export function resolveDataCenterTheme(themeId) {
  return themeById.get(String(themeId || '')) || themeById.get(DEFAULT_DATA_CENTER_THEME_ID);
}

export function getDataCenterThemeStyle(theme) {
  const resolved = resolveDataCenterTheme(theme?.id);
  return {
    '--dc-theme-glow': resolved.palette.glow,
    '--dc-theme-soft-glow': resolved.palette.softGlow,
    '--dc-theme-tail': resolved.palette.tail,
    '--dc-artwork-width': resolved.artwork.width,
    '--dc-artwork-right': resolved.artwork.right,
    '--dc-artwork-bottom': resolved.artwork.bottom,
    '--dc-artwork-scale-x': String(resolved.artwork.scaleX),
    '--dc-artwork-filter': resolved.artwork.filter,
  };
}
